import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import useFetch from '../../../hooks/useAxios';
import CheckoutStepbar from './CheckoutStepbar';
import DiscountCard from './DiscountCard';
import PaymentDetailBox from './PaymentDetailBox';
import PaymentTable from './PaymentTable';
import Button from '../../shared/Button';

const FinalPayment = () => {
  const [phase, setPhase] = useState(1);
  const steps = [
    {
      PhaseNumber: 1,
      phaseName: "ثبت درخواست"
    },
    {
      PhaseNumber: 2,
      phaseName: "تایید میزبان"
    },
    {
      PhaseNumber: 3,
      phaseName: "پرداخت نهایی"
    }
  ];
  const [inforesidencedetail, setinforesidencedetail] = useState() 
  const [reserveinfodetail, setReserveInfodetail] = useState() 
  const {code,slug,id}=useParams()
  const apiGetresidencedetailInfo = useFetch({
    method: "get",
    url: `api/residences/${code}/${slug}`,
    noHeader: true,
    trigger: true,
    argFunc:(res)=>setinforesidencedetail(res.data),
    
    
   
  });
  const navigate = useNavigate()

  const apiReserve = useFetch({
    method: "get",
    url: `api/guest/reserve/${code}/${id}`,
    noHeader: false,
    trigger: true,
    argFunc:(res)=>setReserveInfodetail(res.data.reserve),
    errMessage:(err)=>{toast.error("این اقامتگاه برای شما رزرو نشده"); navigate(-1)}
   
  });
  const postpayment = useFetch({
    method: "post",
    url: `api/guest/instant/${id}`,
    noHeader: false,
    trigger: false,
    argFunc:(res)=> window.location.replace(res.data),
    data:{gateway:"zarinpal"},
  //  errMessage:(err)=>{toast.error("این اقامتگاه برای شما رزرو نشده"); navigate(-1)}
   
  });
  const postpaymentuninstant = useFetch({
    method: "post",
    url: `api/guest/un-instant/${id}`,
    noHeader: false,
    trigger: false,
    argFunc:(res)=> window.location.replace(res.data),
    data:{gateway:"zarinpal"},
   // errMessage:(err)=>{toast.error("این اقامتگاه برای شما رزرو نشده"); navigate(-1)}
   
  });
const pay = ()=>{
  if(inforesidencedetail.instant_reserve === 1){
    postpayment.reFetch()
  }else{
    postpaymentuninstant.reFetch()
  }
}
  return (
    <div className="Checkout">
      <div className="Checkout--bg-header" />
      <CheckoutStepbar PhaseNum={3} PhaseList={steps} />

      <div className="container">
     {inforesidencedetail && !apiReserve.loading &&  <PaymentDetailBox inforesidencedetail={inforesidencedetail} reserveinfodetail={reserveinfodetail}/> }
       <hr className='mb-[50px]'/>
       {/* <DiscountCard/> */}
       {/* <hr className='my-[50px]'/> */}

     {inforesidencedetail && reserveinfodetail && <PaymentTable inforesidencedetail={inforesidencedetail} reserveinfodetail={reserveinfodetail}/>}
       <hr className='my-[50px]'/>
<div className='grid grid-cols-3 gap-[22px] mb-[200px] '>
  <div></div>
  <div></div>
<Button onClick={pay} varient='primary' fullwidth={true}>تکمیل پرداخت</Button>
</div>
  

      </div>
    </div>
  );
}

export default FinalPayment